import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import { useDocumentSearchConditionDeleteDialog } from '../../../hooks/useDialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'
import Button from '../../atoms/inputs/Button'
import { DocumentsSelectors } from '../../../store/documents/selectors'
import { DocumentsActions } from '../../../store/documents'

type DocumentSearchConditionDeleteDialogProps = {
  id: string
}

export default function DocumentSearchConditionDeleteDialog({ id }: DocumentSearchConditionDeleteDialogProps) {
  const { state, close } = useDocumentSearchConditionDeleteDialog()
  const documentSearchConditions = useSelector(DocumentsSelectors.searchConditions)
  const searchCondition = documentSearchConditions.find((item) => item.id === id)
  const dispatch = useDispatch()
  const handleDelete = useCallback(() => {
    dispatch(DocumentsActions.deleteSearchCondition({ id }))
  }, [dispatch, id])
  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="お気に入り検索条件の削除"
      actions={
        <Button color="caution" onClick={handleDelete}>
          削除
        </Button>
      }
    >
      <FlexColumn>
        <FlexRow>
          <Label text={searchCondition?.name ?? ''} />
          <Label text="を削除してよろしいですか？" />
        </FlexRow>
      </FlexColumn>
    </Dialog>
  )
}
